import {BaseQueryFn} from '@reduxjs/toolkit/query';
import {AxiosRequestConfig} from 'axios';
import {instance} from './index';

export const axiosBaseQuery: BaseQueryFn<AxiosRequestConfig> = (config) => instance.request(config);
